import React from 'react'
import logo from '../images/logo.svg'
import '../styles/footer.css'
import facebook from '../images/icon-facebook.svg'
import pinterest from '../images/icon-pinterest.svg'
import twitter from '../images/icon-twitter.svg'
import youtube from '../images/icon-youtube.svg'
import instagram from '../images/icon-instagram.svg'
const Footer = () => {
	return <footer>
		<div className="footer__container">
			<div className="footer__socials">
				<img src={logo} alt="Easybank"/>
				<div className="footer__socials__medias">
					<a href="#"><img src={facebook} /></a>
					<a href="#"><img src={pinterest} /></a>
					<a href="#"><img src={twitter} /></a>
					<a href="#"><img src={youtube} /></a>
					<a href="#"><img src={instagram} /></a>
				</div>
			</div>

			<ul className="footer__infos">
				<li><a href="#">About Us</a></li>
				<li><a href="#">Contact</a></li>
				<li><a href="#">Blogs</a></li>
			</ul>

			<ul className="footer__infos flex-1">
				<li><a href="#">Careers</a></li>
				<li><a href="#">Support</a></li>
				<li><a href="#">Privacy Policy</a></li>
			</ul>

			<div className="copy__button">
				<button className="footer__btn">Request Invite</button>
				<p>&Easybank. All Rights Reserved.</p>
			</div>
		</div>

	</footer>
}

export default Footer;